import React from "react";
import { Spin, theme } from "../ui";
import { windowHeight } from "../theme/displayZoom";

/**
 * Vollflächiger Lade-Indikator für Route-/Suspense-Boundaries (ganze Seite).
 * Für lokale Bereiche innerhalb einer Seite stattdessen `InlineLoading` verwenden.
 */
export const PageLoading: React.FC = () => {
  const {
    token: { colorBgLayout, colorTextSecondary },
  } = theme.useToken();

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: windowHeight("100vh"),
      width: "100%",
      background: colorBgLayout,
      color: colorTextSecondary,
    }}>
      <Spin size="large" />
    </div>
  );
};
